import React, { PropTypes } from 'react';
import ContractingYear from '../../template-list/create-template-draft/components/contracting-year';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import StepperActions from '../../generic-components/stepper-actions';
const EditContractPeriod = (props) => {
  const {
    contractId,
    onTextFieldChangeWithKeyPath,
    saving,
    onRequestClose,
    data: {
      newStartDate,
      newEndDate,
    },
    saveSupplierInfoChanges,
  } = props;
  const onClickSave = () => saveSupplierInfoChanges({ contractId, data: { newStartDate, newEndDate }, updateType: 'SAVE_CONTRACT_PERIOD' });
  const onDateChange = (key, value) => onTextFieldChangeWithKeyPath({
    keyPath: ['data', `new${key === 'startDate' ? 'StartDate' : 'EndDate'}`],
    value,
  });
  return (
    <div style={{ padding: '0 12px 12px 12px' }}>
      <div style={{ padding: '20px' }}>
        <ContractingYear
          required
          startDate={newStartDate}
          endDate={newEndDate}
          onChange={onDateChange}
        />
      </div>
      <StepperActions
        rightButtons={
          <div>
            <FlatButton
              label="Dismiss"
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              primary
              onClick={onRequestClose}
            />
            <FlatButton
              label="Save"
              loader={saving}
              onClick={onClickSave}
              labelStyle={{ fontWeight: '600', marginRight: '15px' }}
              secondary
            />
          </div>
        }
      />
    </div>
  );
};

EditContractPeriod.propTypes = {
  onTextFieldChangeWithKeyPath: PropTypes.func,
  saving: PropTypes.bool,
  onRequestClose: PropTypes.func,
  saveSupplierInfoChanges: PropTypes.func,
  contractId: PropTypes.string,
  data: PropTypes.object,
};

export default EditContractPeriod;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/update-contracting-period.jsx